import React from "react";
import InputBox from "../reusable/InputBox/InputBox.jsx";
import If from "../reusable/If/If.jsx";
import PropTypes from "prop-types";
import Select from "react-select";
import Alert from "react-s-alert";
import { json as ajax } from "./../../ajax.js";
import { CONSTANTS } from "../reusable/Constants/constants";
import { formatCurrency } from "../reusable/Utilities/format.js";

export default class LaborTableRow extends React.Component {

    ZINDEX = 10;

  static propTypes = {
    labor: PropTypes.object,
    claimObject: PropTypes.object.isRequired,
    index: PropTypes.number,
    complaintIndex: PropTypes.number,
    handlePartLaborUpdate: PropTypes.func.isRequired,
    removePartOrLabor: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
    showRequiredNoteError: PropTypes.bool,
    allDataComponents: PropTypes.array
  };

  state = {
    laborDescriptionOptions: [],
    loadedComponentHref: '',
    selectedLaborDescriptions: [],
    pendingLaborOptionLoad: false
  };

  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps, prevState){
    if(this.props.claimObject.labor_rate !== prevProps.claimObject.labor_rate){
      const approvedValue = parseFloat(this.getApprovedAmount(this.props.claimObject, this.props.labor));
      this.props.handlePartLaborUpdate('labors', this.props.labor.id, 'approved', approvedValue);
    }

    if (
      this.props.labor.labor_description !== prevProps.labor.labor_description ||
      this.state.laborDescriptionOptions !== prevState.laborDescriptionOptions
    ) {
      this.syncSelectedLaborDescriptions();
    }
    if (
      this.state.pendingLaborOptionLoad &&
      Array.isArray(this.props.allDataComponents) &&
      this.props.allDataComponents.length
    ) {
      this.setState({ pendingLaborOptionLoad: false });
      this.loadLaborDescriptionOptionsForSavedComponent();
    }
  }

  componentDidMount() {
    this.syncSelectedLaborDescriptions();
  }

  handleLaborDescriptionMenuOpen = () => {
    if (this.props.isDisabled) return;
    const components = this.props.allDataComponents;
    if (!Array.isArray(components) || !components.length) {
      this.setState({ pendingLaborOptionLoad: true });
      return;
    }
    this.loadLaborDescriptionOptionsForSavedComponent();
  };

  syncSelectedLaborDescriptions = () => {
    const savedDescription = this.props.labor.labor_description;
    const laborDescriptionData = Array.isArray(this.state.laborDescriptionOptions)
      ? this.state.laborDescriptionOptions
      : [];

    const laborDescriptionSelectOptions = laborDescriptionData.map(labor => {
      const operation = labor.operation || '';
      const qualifier = labor.qualifier || '';
      const hours = labor.standard_time || '';
      const displayValue = qualifier ? `${operation} - ${qualifier} - ${hours}` : operation;
      return {
        value: displayValue,
        label: displayValue,
        hours
      };
    });

    const selectedLaborDescriptions = savedDescription
      ? savedDescription.split('; ').filter(Boolean).map(val => {
        const found = laborDescriptionSelectOptions.find(option => option.value === val);
        return found || { value: val, label: val, hours: '' };
      })
      : [];

    const currentStateValue = JSON.stringify(
      this.state.selectedLaborDescriptions.map(option => ({
        value: option.value,
        hours: option.hours || ''
      }))
    );
    const nextStateValue = JSON.stringify(
      selectedLaborDescriptions.map(option => ({
        value: option.value,
        hours: option.hours || ''
      }))
    );
    if (currentStateValue !== nextStateValue) {
      this.setState({ selectedLaborDescriptions });
    }
  };

  loadLaborDescriptionOptionsForSavedComponent = () => {
    const selectedComponent = this.props.labor.component;
    const allDataComponents = this.props.allDataComponents;

    if (!selectedComponent || !Array.isArray(allDataComponents) || !allDataComponents.length) {
      return;
    }

    const componentRecord = allDataComponents.find(component => component.display_name === selectedComponent);
    const hrefText = componentRecord && componentRecord.href;

    if (!hrefText) {
      return;
    }

    const encodedHref = encodeURIComponent(hrefText);
    if (encodedHref === this.state.loadedComponentHref) {
      return;
    }

    const url = `/api/all-data-components/details?href=${encodedHref}`;
    ajax(url, {}, {}, (data, status) => {
      if (status === 200) {
        this.setState({
          laborDescriptionOptions: data.component_details,
          loadedComponentHref: encodedHref
        });
      }
    });
  };

  onBlur = (field, value) => {
    let approvedAmount = parseFloat(this.props.labor.approved),
      billedAmount = parseFloat(this.props.labor.billed);

    if (field === 'hours') {
      approvedAmount = parseFloat(this.getApprovedAmount(this.props.claimObject, this.props.labor));
      this.props.handlePartLaborUpdate('labors', this.props.labor.id, 'approved', approvedAmount.toFixed(2));
    } else if(field === 'requested'){
      billedAmount = this.getBilledAmount(this.props.claimObject, this.props.labor);
      this.props.handlePartLaborUpdate('labors', this.props.labor.id, 'billed', billedAmount.toFixed(2));
    } else if(field === 'approved') {
      approvedAmount = parseFloat(value);
      this.props.handlePartLaborUpdate('labors', this.props.labor.id, field, value);
    } else if(field === 'billed') {
      billedAmount = parseFloat(value);
      this.props.handlePartLaborUpdate('labors', this.props.labor.id, field, value);
    }
  };

  getApprovedAmount = ({ labor_rate }, { hours }) => {
    if(labor_rate && hours) {
      return (parseFloat(labor_rate) * parseFloat(hours)).toFixed(2);
    } else {
      return 0;
    }
  };

  getBilledAmount = ({ labor_rate },{ requested }) => {
    if(labor_rate && requested){
      return (parseFloat(labor_rate) * parseFloat(requested));
    } else {
      return 0;
    }
  };

  getOptions = () => {
    return CONSTANTS.LABOR_PAID_SHORT.map((element) => {
      return {
        value: element,
        label: element
      };
    });
  };

  onLaborNoteChange = (laborObject) => {
    if(laborObject){
      this.props.handlePartLaborUpdate('labors', this.props.labor.id, 'notes', laborObject.value);
    } else {
      this.props.handlePartLaborUpdate('labors', this.props.labor.id, 'notes', '');
    }
  };

  handleOnChangeOfComponent = (componentOption) => {
    this.props.handlePartLaborUpdate('labors', this.props.labor.id, 'labor_description', '');
    if (!componentOption) {
      this.setState({ laborDescriptionOptions: [], loadedComponentHref: '', selectedLaborDescriptions: [] });
      this.props.handlePartLaborUpdate('labors', this.props.labor.id, 'component', '');
      return;
    }

    const selectedComponent = componentOption.value || '';
    this.props.handlePartLaborUpdate('labors', this.props.labor.id, 'component', selectedComponent);

    if (!componentOption.href_text) {
      this.setState({ laborDescriptionOptions: [], loadedComponentHref: '', selectedLaborDescriptions: [] });
      return;
    }

    // need to call api and also set the value in the input box
    const encodedHref = encodeURIComponent(componentOption.href_text);
    const url = `/api/all-data-components/details?href=${encodedHref}`;
    ajax(url, {}, {}, (data, status) => {
      if (status === 200) {
        this.setState({ laborDescriptionOptions: data.component_details, loadedComponentHref: encodedHref });
        this.props.handlePartLaborUpdate('labors', this.props.labor.id, 'labor_description', '');
      } else {
        Alert.error('Error while fetching the car component details');
      }
    });
  };

  handleOnChangeOfLaborDescription = (selectedOptions) => {
    const options = Array.isArray(selectedOptions)
      ? selectedOptions
      : (selectedOptions ? [selectedOptions] : []);

    const storedValue = options.length ? options.map(o => o.value).join('; ') : '';

    this.setState({ selectedLaborDescriptions: options });
    this.props.handlePartLaborUpdate('labors', this.props.labor.id, 'labor_description', storedValue);

    // Only AllData options carry a standard time. Free-typed (Creatable) entries
    // and options with a blank standard_time have no hours, so leave whatever the
    // adjuster entered manually alone rather than zeroing Hours/Approved. Refs: TS-16917
    const timedOptions = options.filter(o => parseFloat(o.hours) > 0);
    if (!timedOptions.length) {
      return;
    }
    const totalHours = timedOptions.reduce((sum, o) => sum + parseFloat(o.hours), 0);
    this.props.handlePartLaborUpdate('labors', this.props.labor.id, 'hours', totalHours.toFixed(2));
    const approvedAmount = this.getApprovedAmount(this.props.claimObject, { hours: totalHours });
    this.props.handlePartLaborUpdate('labors', this.props.labor.id, 'approved', approvedAmount);
  };

  render() {
    const billed = parseFloat(this.props.labor.billed);
    const approved = parseFloat(this.props.labor.approved);
    let borderStyle = {};

    if(billed < approved){
      borderStyle = {
        "border": "1px solid #dc3545",
        "borderRadius": "0.2rem"
      };
    }

    let selectedNoteOption;
    const note = this.props.labor.notes;

    if(note){
      selectedNoteOption = {
        label: note,
        value: note
      };
    }
    const laborDescriptionData = Array.isArray(this.state.laborDescriptionOptions)
      ? this.state.laborDescriptionOptions
      : [];

    const laborDescriptionSelectOptions = laborDescriptionData.map(labor => {
      const operation = labor.operation || '';
      const qualifier = labor.qualifier || '';
      const hours = labor.standard_time || '';
      const displayValue = qualifier ? `${operation} - ${qualifier} - ${hours}` : operation;
      return {
        value: displayValue,
        label: displayValue,
        hours
      };
    });

    const componentSelectOptions = this.props.allDataComponents?.map(component => {
      return {
        value: component.display_name,
        label: component.display_name,
        href_text: component.href
      };
    }) || [];

    const selectedComponentOption = componentSelectOptions
      .find(option => option.value === this.props.labor.component) || null;

    const componentValue = selectedComponentOption ||
      (this.props.labor.component ? {
        value: this.props.labor.component,
        label: this.props.labor.component
      } : null);

    const laborDescriptionValue = this.state.selectedLaborDescriptions.length
      ? this.state.selectedLaborDescriptions
      : null;

    return (
      <tbody className="border-top-0">
        <tr className="row col-12 pr-0">
          <td className="col-3 border-bottom-0">
            <Select type="Text"
              id={ `complaint-${this.props.complaintIndex}-component-inputBox-${this.props.index}` }
              disabled={ this.props.isDisabled }
              value={ componentValue }
              options={ componentSelectOptions }
              //on change also need to call an api to get labor description options based on component description selection,
              onChange={ this.handleOnChangeOfComponent }/>
          </td>
          <td className="col-3 border-bottom-0">
            <Select.Creatable
              type="Text"
              multi={true}
              id={`complaint-${this.props.complaintIndex}-labor-description-inputBox-${this.props.index}`}
              disabled={this.props.isDisabled}
              value={laborDescriptionValue}
              options={laborDescriptionSelectOptions}
              placeholder="Type or select labor description"
              onOpen={this.handleLaborDescriptionMenuOpen}
              onChange={this.handleOnChangeOfLaborDescription}/>
          </td>
          <td className="col-1 border-bottom-0">
            <InputBox type="Number"
              hasDefaultValue={ true }
              id={ `complaint-${this.props.complaintIndex}-requested-inputBox-${this.props.index}` }
              isDisabled={ this.props.isDisabled }
              value={ this.props.labor.requested }
              onChange={ this.props.handlePartLaborUpdate.bind(null, 'labors', this.props.labor.id, 'requested') }
              onBlur={ this.onBlur.bind(null, 'requested') }/>
          </td>
          <td className="col-1 border-bottom-0">
            <InputBox type="Number"
              hasDefaultValue={ true }
              id={ `complaint-${this.props.complaintIndex}-hours-inputBox-${this.props.index}` }
              isDisabled={ this.props.isDisabled }
              value={ this.props.labor.hours }
              onChange={ this.props.handlePartLaborUpdate.bind(null, 'labors', this.props.labor.id, 'hours') }
              onBlur={ this.onBlur.bind(null, 'hours') }/>
          </td>
          <td className="col border-bottom-0">
            <InputBox type="Currency"
              id={ `complaint-${this.props.complaintIndex}-labor-rate-inputBox-${this.props.index}` }
              isDisabled={ true }
              value={ formatCurrency(this.props.claimObject.labor_rate) }/>
          </td>
          <td className="col border-bottom-0">
            <InputBox type="Currency"
              style={ borderStyle }
              id={ `complaint-${this.props.complaintIndex}-billed-inputBox-${this.props.index}` }
              isDisabled={ this.props.isDisabled }
              value={ formatCurrency(this.props.labor.billed) }
              onBlur={ this.onBlur.bind(null, 'billed') }/>
          </td>
          <td className="col border-bottom-0">
            <InputBox type="Currency"
              style={ borderStyle }
              hasDefaultValue={ true }
              id={ `complaint-${this.props.complaintIndex}-approved-inputBox-${this.props.index}` }
              isDisabled={ this.props.isDisabled }
              value={ formatCurrency(this.props.labor.approved) }
              onBlur={ this.onBlur.bind(null, 'approved') }/>
          </td>
          <td className="h5">
            <i className="fa fa-times cursor-pointer"
              id={ `complaint-${this.props.complaintIndex}-delete-labor-${this.props.index}` }
              onClick={ !this.props.isDisabled ? this.props.removePartOrLabor.bind(null, this.props.labor.id) : () => {}}/>
          </td>
        </tr>
        <If condition={ billed > approved }>
          <tr className="row col-12">
            <td className="col border-top-0">
              <Select.Creatable value={ selectedNoteOption }
                id={ `complaint-${this.props.complaintIndex}-labor-note-inputBox-${this.props.index}` }
                disabled={ this.props.isDisabled }
                options={ this.getOptions() }
                onChange={ this.onLaborNoteChange }
                menuContainerStyle={ { zIndex: this.ZINDEX } }
                placeholder="Type or select reason"
                tabSelectsValue={ false }
                matchProp='label'/>
              <If condition={ this.props.showRequiredNoteError && !this.props.labor.notes }>
                <span className="text-danger">Required Note for approved amount less than billed amount.</span>
              </If>
            </td>
          </tr>
        </If>
        <If condition={ billed < approved }>
          <tr className="row col-12">
            <td className="col border-top-0 text-right">
              <span className="text-danger">Approved amount is greater than billed amount.</span>
            </td>
          </tr>
        </If>
      </tbody>
    );
  }
}